import { __makeTemplateObject } from "tslib";
import { css } from 'emotion';
import React from 'react';
// An abstraction over a component rendered within a chart canvas.
// Marker is rendered with DOM coords of the chart bounding box.
export var Marker = function (_a) {
    var x = _a.x, y = _a.y, children = _a.children;
    return (React.createElement("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: absolute;\n        top: ", "px;\n        left: ", "px;\n        transform: translate3d(-50%, -50%, 0);\n      "], ["\n        position: absolute;\n        top: ", "px;\n        left: ", "px;\n        transform: translate3d(-50%, -50%, 0);\n      "])), y, x) }, children));
};
var templateObject_1;
//# sourceMappingURL=Marker.js.map